<script lang="ts" setup>
const props = withDefaults(defineProps<Props>(), {
  icon: null,
  type: 'button',
  disabled: false,
})

interface Props {
  icon?: null | string
  type?: string
  disabled?: boolean
}

const emit = defineEmits<{
  (e: 'click', event: MouseEvent): void
}>()

function onClick(event: MouseEvent) {
  emit('click', event)
}
</script>

<template>
  <button :type="type" class="btn btn-primary py-12" :disabled="disabled" @click="onClick">
    <span v-if="props.icon">{{ icon }}</span>
    <slot />
  </button>
</template>
